import { createTheme } from '@mui/material/styles';

export const getTheme = (mode: 'light' | 'dark') =>
  createTheme({
    palette: {
      mode,

      primary: {
        main: mode === 'dark' ? '#7AA2FF' : '#114EC7',
        light: mode === 'dark' ? '#AFC4FF' : '#5C94FF',
        contrastText: mode === 'dark' ? '#000000' : '#ffffff'
      },

      secondary: {
        main: mode === 'dark' ? '#ffffff' : '#1f1f1f'
      },

      info: {
        main: mode === 'dark' ? '#8FB0FF' : '#5C94FF',
        light: '#DEEAFF'
      },

      error: {
        main: mode === 'dark' ? '#E57373' : '#CF352F',
        light: mode === 'dark' ? '#3A1F1F' : '#FAEBEA'
      },

      background: {
        default: mode === 'dark' ? '#121212' : '#f7f7f8',
        paper: mode === 'dark' ? '#1e1e1e' : '#f3f4f6'
      },

      text: {
        primary: mode === 'dark' ? '#f5f5f5' : '#1f1f1f',
        secondary: mode === 'dark' ? '#b3b3b3' : '#595959'
      },

      divider: mode === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)'
    },

    typography: {
      fontFamily: ['Inter', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Arial', 'sans-serif'].join(','),

      fontSize: 15,

      body1: {
        lineHeight: 1.55
      },

      body2: {
        lineHeight: 1.5
      },

      caption: {
        fontSize: '0.8rem',
        lineHeight: 1.4
      },

      subtitle1: {
        fontWeight: 600
      },

      subtitle2: {
        fontWeight: 600
      },

      h1: {
        fontSize: '2.1rem',
        fontWeight: 700
      },

      h2: {
        fontSize: '1.7rem',
        fontWeight: 700
      },

      h3: {
        fontSize: '1.45rem',
        fontWeight: 600
      },

      h4: {
        fontSize: '1.25rem',
        fontWeight: 600
      },

      h5: {
        fontSize: '1.05rem',
        fontWeight: 600
      },

      h6: {
        fontSize: '0.95rem',
        fontWeight: 600
      },

      button: {
        textTransform: 'none',
        fontWeight: 500
      }
    },

    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            scrollbarColor: mode === 'dark' ? '#6b6b6b #1e1e1e' : '#bdbdbd #ffffff'
          }
        }
      },

      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            padding: '6px 14px'
          }
        }
      },

      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 6,
            fontWeight: 500
          }
        }
      },

      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12
          }
        }
      },

      MuiAccordion: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            '&:before': {
              display: 'none'
            }
          }
        }
      },

      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 8
          }
        }
      },

      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '0.8rem'
          }
        }
      }
    }
  });
